export const billingKeys = {
  all: ['billing'] as const,
  account: () => [...billingKeys.all, 'account'] as const,
};
